import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DuplicateResolutions } from '../../../model/duplicate-resolutions';
import { StudentDeduplicationService } from '../../../service/student-deduplication.service';
import { MsgModel } from 'src/app/component/common-components/msg/model/msg.model';
import { StudentHelperService } from '../../../service/student-helper.service';
import { StudentHelper2Service } from '../../../service/student-helper2.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'merge-children-modal',
    templateUrl: './merge-children-modal.component.html',
    styleUrls: ['./merge-children-modal.component.scss']
})
export class MergeChildrenModalComponent {
    msg: MsgModel;
    duplicateResolution: DuplicateResolutions;
    studentId1: number;
    studentId2: number;

    studentName1: string;
    regions1: string;
    terminated1: string;
    studentName2: string;
    regions2: string;
    terminated2: string;

    isLoading: boolean;
    isResolving: boolean;

    subs: Subscription[] = [];

    constructor(
        public dialogRef: MatDialogRef<MergeChildrenModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        public studentDeduplicationService: StudentDeduplicationService,
        private studentHelperService: StudentHelperService,
        private studentHelper2Service: StudentHelper2Service
    ) {}

    ngOnInit(): void {
        this.isLoading = true;
        this.subscriptions();

        if (this.data) {
            this.duplicateResolution = this.data.duplicateResolution;

            if (this.duplicateResolution && this.duplicateResolution.ID) {
                this.studentId1 = this.duplicateResolution.DUPLICATE_RESOLUTION_STUDENTS[0].STUDENTS_ID;
                this.studentId2 = this.duplicateResolution.DUPLICATE_RESOLUTION_STUDENTS[1].STUDENTS_ID;
                this.studentHelperService.setStudentId(this.studentId1);
                this.studentHelper2Service.setStudentId(this.studentId2);
            }
        }

        this.isLoading = false;
    }

    subscriptions() {
        let studentNameSub = this.studentHelperService.studentName$.subscribe((studentName) => {
            this.studentName1 = studentName;
        });
        let studentNameSub2 = this.studentHelper2Service.studentName$.subscribe((studentName) => {
            this.studentName2 = studentName;
        });

        this.subs.push(studentNameSub);
        this.subs.push(studentNameSub2);

        let regionsSub = this.studentHelperService.regions$.subscribe((regions) => {
            this.regions1 = regions;
        });

        let regionsSub2 = this.studentHelper2Service.regions$.subscribe((regions) => {
            this.regions2 = regions;
        });

        this.subs.push(regionsSub);
        this.subs.push(regionsSub2);

        let terminatedSub = this.studentHelperService.terminated$.subscribe((terminated) => {
            this.terminated1 = terminated;
        });

        let terminatedSub2 = this.studentHelper2Service.terminated$.subscribe((terminated) => {
            this.terminated2 = terminated;
        });

        this.subs.push(terminatedSub);
        this.subs.push(terminatedSub2);
    }

    ngOnDestroy(): void {
        this.subs.forEach((sub) => {
            sub.unsubscribe();
        });
    }

    closeDialog(closed: boolean) {
        this.data = { msg: this.msg, closed: closed };
        this.dialogRef.close(this.data);
    }

    resolveDuplicateResolutionMerged(duplicateResolution: DuplicateResolutions) {
        this.isResolving = true;

        this.studentDeduplicationService.resolveDuplicateResolutionMerged(duplicateResolution).subscribe((res) => {
            if (res.msg) {
                if (res.msg.SUCCESS) {
                    this.data.msg = res.msg;
                    this.duplicateResolution.DUPLICATE_RESOLUTION_TYPES.TYPE = 'Resolved';
                    this.data.duplicateResolution = this.duplicateResolution;

                    setTimeout(() => {
                        this.dialogRef.close(this.data);
                    }, 500);
                } else {
                    this.msg = res.msg;
                    this.isResolving = false;
                }
            } else {
                this.msg = new MsgModel();
                this.msg.SUCCESS = false;
                this.msg.MSG = 'Failed to merge students. Server error.';
                this.isResolving = false;
            }
        });
    }
}
